import {Link} from "react-router-dom";

export const ServerError = () => {
  return (
    <div
      className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <h1 className="text-9xl font-extrabold text-red-500">500</h1>
        <h2 className="mt-6 text-3xl font-bold text-gray-900">Something went wrong</h2>
        <h3 className="text-lg font-medium text-gray-900">We are working to fix this problem</h3>
        <div className="mt-8">
          <Link to="https://fortworx.com" className="text-blue-600 hover:text-blue-800 transition-colors duration-300">
            Visit Fortworx
          </Link>
        </div>
      </div>
    </div>
  )
};
